import React, {memo} from 'react';
import AskODOT from '../AskODOT.png';
import TripCheck from '../TripCheck.png';
//Get rid of homeContainerLink??
function Home() {
    return (
        <div style={{overflowY: "auto"}}>
            <div id="homeContainer">
                <h2>Find a project</h2>
                <p>We can help you find the transportation projects that matter to you.</p>
                <p><strong>Interact with the map</strong> to find mapped projects throughout the state. Zoom in to see more detail or use search tools to find mapped and non-mapped projects.</p>
                <p><strong>Search by keyword</strong> &#8212; Search for projects by name, project number or location.</p>
                <p><strong>Phase</strong> &#8212; Select projects that are in planning, design or construction or find completed projects. Projects labeled “other” are non-construction projects.</p>
                <p><strong>Type</strong> &#8212; Look for projects of a specific type, like bicycle/pedestrian, bridge or transit.</p>
                <p><strong>Performance</strong> &#8212; See on time and on budget status for completed ODOT construction projects. </p>
                <p><strong>Year</strong> &#8212; Filter by completion date for completed projects, estimated completion date for construction projects, and bid date for design projects. </p>
                <p><strong>Administrator</strong> &#8212; Explore who is responsible for project contract and delivery.</p>
                <p><strong>Location</strong> &#8212; Review projects in a specific city, county or other geographic area.</p>
                <p><strong>Mapped</strong> &#8212; See only mapped or non-mapped projects.</p>
                <h3>How can we help?</h3>
                <p><a href="https://www.oregon.gov/ODOT/Projects/Pages/UsingTPT.aspx">Learn more about the application, including tips and tricks</a>. This application works best in Chrome, Safari or Edge. For questions, <a href="https://www.oregon.gov/odot/Pages/Ask-ODOT.aspx">submit a question to Ask ODOT</a> and mention the Transportation Project Tracker.</p>
                <div className="row" style={rowMarginFix}>
                    <div className="col-sm text-center">
                        <a href="https://www.oregon.gov/odot/Pages/Ask-ODOT.aspx"><img alt="Ask ODOT Logo" src={AskODOT} style={imageLink} /></a>
                    </div>
                    <div className="col-sm text-center">
                        <a href="https://www.tripcheck.com/"><img alt="TripCheck Logo" src={TripCheck} style={imageLink} /></a>
                    </div>
                </div>
                
                <p style={versionText}>
                    Transportation Project Tracker - Version: 1.3.8 - Release: 08/05/2024
                </p>
            </div>
        </div>
    );
}

export default memo(Home);

let homeContainerLink = {
    textDecoration: "underline"
};
let imageLink = {
    marginBottom: "10px",
    maxWidth: "100px",
    minWidth: "50%"
};
let rowMarginFix = {
    margin: "20px 0  0"
}
let versionText={
    color: "#aaa",
    fontSize: "12px",
    margin: "20px 0 5px"
}